import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVa = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 59 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M36.747 29a2 2 0 011.418.59h0l8.432 10.134 10.183 4.43a1.998 1.998 0 011.213 1.673h0L58 52a1.997 1.997 0 01-1.833 1.993h0l-1.317.004a7.49 7.49 0 01-2.256 4.008A7.474 7.474 0 0147.5 60a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 0140.15 54h0-19.3a7.49 7.49 0 01-2.256 4.005A7.474 7.474 0 0113.5 60a7.474 7.474 0 01-5.094-1.995A7.49 7.49 0 016.15 54h0-3.152a1.997 1.997 0 01-1.993-1.83h0L.948 31.001a1.996 1.996 0 011.836-1.995h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26 30v8h20v2H26a2 2 0 01-2-2v-8h2z",
				fill: "#0D0E10"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 13.5,
				cy: 52.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 47.5,
				cy: 52.5,
				r: 2.5
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 4,
				y: 32,
				width: 2,
				height: 16,
				rx: 1
			})
		]
	})
});
export default SvgVa;
